import { render, staticRenderFns } from "./LgameLoaderComp.vue?vue&type=template&id=395a1711&scoped=true&"
import script from "./LgameLoaderComp.vue?vue&type=script&lang=js&"
export * from "./LgameLoaderComp.vue?vue&type=script&lang=js&"
import style0 from "./LgameLoaderComp.vue?vue&type=style&index=0&id=395a1711&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395a1711",
  null
  
)

export default component.exports